export default __webpack_public_path__ + "static/media/after.c9281ca5.png";